import selectors from './selectors';
import actions from './actions';
import may from './may';
import reducer from './reducer';
import { createModuleDescriptor } from '../../redux/module-descriptor';

export * from './sagaUtils';

const auth = createModuleDescriptor('auth', {
  actions,
  selectors,
  may,
  reducer,
});

export default { ...auth, may };
